import { css } from 'linaria';

export const variantsAxisContainer = css`
  margin-top: var(--space-300);
`;
